import { render, staticRenderFns } from "./ReferenceTagSlider.vue?vue&type=template&id=42d307e5"
import script from "./ReferenceTagSlider.vue?vue&type=script&lang=js"
export * from "./ReferenceTagSlider.vue?vue&type=script&lang=js"
import style0 from "./ReferenceTagSlider.vue?vue&type=style&index=0&id=42d307e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports